import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext, useRef } from 'react';
import { ModalContext } from '../contexts/ModalContext';

export default function Modal() {
  const [modal, , deactivateModal] = useContext(ModalContext);
  const modalDialogBox = useRef();

  return (
    <>
      {modal ? (
        <div className="pop-up" style={{ zIndex: 1000 }}>
          <div className="pop-up__dialog" ref={modalDialogBox}>
            <button
              className="btn btn-dark btn-sm p-0"
              type="button"
              onClick={deactivateModal}
              style={{
                borderRadius: '50%',
                width: '25px',
                height: '25px',
                position: 'absolute',
                top: '1rem',
                right: '1rem',
              }}
            >
              <FontAwesomeIcon icon={faTimes} />
              <span className="sr-only">Close</span>
            </button>

            <p>
              <b>Stone ID: {modal.selectedStone.id}</b>
            </p>

            {!modal.selectedStone.classList.contains('sponsored') ? (
              modal.fact ? (
                <p>{modal.fact}</p>
              ) : null
            ) : null}

            {modal.disableBasket ? (
              modal.sponsorPublicStatus === 'yourname' ? (
                <p className="font-weight-bold">
                  This stone is sponsored by {modal.sponsorName}
                </p>
              ) : modal.sponsorPublicStatus === 'giftedby' ? (
                <p className="font-weight-bold">
                  This stone was gifted by {modal.sponsorName}
                </p>
              ) : modal.sponsorPublicStatus === 'anonymous' ? (
                <p className="font-weight-bold">
                  This stone is sponsored by anonymous
                </p>
              ) : null
            ) : (
              <p className="font-weight-bold">This stone is unavailable</p>
            )}
          </div>
        </div>
      ) : null}
    </>
  );
}
